<template>
	<div class="login">
		<div class="site-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-sm-6">
						<div class="card">
							<div class="card-header text-light" style="background: #0F182B;">
								<h3>Inicia sesión</h3>
							</div>
							<div class="card-body">
							<b-form @submit="onSubmitLogin" @reset="onReset" >
									<b-form-group id="email-group" label="Correo electrónico" label-for="email">
										<b-form-input id="email" v-model="user.email" type="email" required placeholder="ejemplo@mail.com"></b-form-input>
									</b-form-group>
									<b-form-group id="password-group" label="Contraseña" label-for="password">
										<b-form-input id="password" v-model="user.password" type="password" placeholder="******" required></b-form-input>
									</b-form-group>
									<b-button class="btn text-light" type="submit" style="background: #0F182B; font-weight:bold; width: 175px; height: 40px;">
										INICIAR SESIÒN
									</b-button>
								</b-form>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-6">
						<div class="card">
							<div class="card-header text-light" style="background: #0F182B;">
								<h3>¿Ya te registraste, hijo? Si todavia no lo has hecho, hazlo aquí.</h3>
							</div>
							<div class="card-body">
								<b-form @submit="onSubmitRegister" @reset="onReset" >
									<b-form-group id="name-group" label="Nombre(s)" label-for="name">
										<b-form-input id="name" v-model="user.name" type="text" required ></b-form-input>
									</b-form-group>
									<b-form-group id="lastname-group" label="Apellido Paterno" label-for="lastname">
										<b-form-input id="lastname" v-model="user.lastname" type="text" required ></b-form-input>
									</b-form-group>
									<b-form-group id="surname-group" label="Apellido Materno" label-for="surname">
										<b-form-input id="surname" v-model="user.surname" type="text" required ></b-form-input>
									</b-form-group>
									<b-form-group id="phone-group" label="Telefono" label-for="phone">
										<b-form-input id="phone" v-model="user.phone" type="tel" required ></b-form-input>
									</b-form-group>
									<b-form-group id="email-group" label="Correo electrónico" label-for="email">
										<b-form-input id="email" v-model="user.email" type="email" required ></b-form-input>
									</b-form-group>
									<b-form-group id="password-group" label="Contraseña" label-for="password">
										<b-form-input id="password" v-model="user.password" type="password" required></b-form-input>
									</b-form-group>
									<b-button class="btn text-light" type="submit" style="background: #0F182B; font-weight:bold; width: 175px; height: 40px;">
										REGISTRARME
									</b-button>
								</b-form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const axios = require('axios');
export default {
	name: 'LoginForm',
	data(){
		return{
			api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
			base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
			user: {
				name: '',
				lastname: '',
				surname: '',
				email: '',
				phone: '',
				password: ''
			},
			show: true,
		}
	},
	methods:{
		onSubmitLogin: function(evt){
			evt.preventDefault();
			if ($cookies.isKey('ctoken')) {
				axios({
					method: 'POST',
					url: this.api_url+'/subscribers/login',
					data: {
						email: this.user.email,
						password: this.user.password,
					},
					headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+$cookies.get('ctoken')}
				})
				.then(response => {
					var today = new Date();
					console.log(response);
					console.info('Se obtuvo el token del usuario');
					if (response.data.is_logged) {
						this.$snotify.success(response.data.response);
						this.show = false;
						//$cookies.set('utoken', response.data.token, today.getTime() + 3600000*24*7, '/', null, true, 'Lax');
						$cookies.set('utoken', response.data.token, today.getTime() + 3600000*24*7);
						$cookies.set('uidmmkg', response.data.user.id, today.getTime() + 3600000*24*7);
						this.$router.push({name: 'checkout'});
					}else{
						this.$snotify.warning(response.data.response);
					}
				})
				.catch(error => {
					console.error(error);
				});
			}else{
				this.$snotify.info("No se ha podido registrar al usuario. -- Err 002");
			}
		},
		onSubmitRegister: function(evt){
			evt.preventDefault();
			if ($cookies.isKey('ctoken')) {
				axios({
					method: 'POST',
					url: this.api_url+'/subscribers',
					data: {
						name: this.user.name,
						lastname: this.user.lastname,
						surname: this.user.surname,
						phone: this.user.phone,
						email: this.user.email,
						password: this.user.password,
					},
					headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+$cookies.get('ctoken')}
				})
				.then(response => {
					var today = new Date();
					console.log(response);
					console.info('Se obtuvo el token del usuario');
					if (response.data.is_logged) {
						this.$snotify.success(response.data.response);
						this.show = false;
						//$cookies.set('utoken', response.data.token, today.getTime() + 3600000*24*7, '/', null, true, 'Lax');
						$cookies.set('utoken', response.data.token, today.getTime() + 3600000*24*7);
						$cookies.set('uidmmkg', response.data.user.id, today.getTime() + 3600000*24*7);
						this.$router.push({name: 'checkout'});
					}else{
						this.$snotify.warning(response.data.response);
					}
				})
				.catch(error => {
					console.error(error);
				});
			}else{
				this.$snotify.info("No se ha podido registrar al usuario. -- Err 002");
			}
		},
		onReset: function(evt){
			evt.preventDefault();
			console.info("Reseteando");
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
